export default {
  Month: 0,
  Quarter: 1,
};
